import { useEffect, useState } from "react";
import { useDyteMeeting } from "@dytesdk/react-web-core";
import { defaultConfig } from "@dytesdk/ui-kit";

import { setupMeetingConfigs } from "../../../../../lib/utils";
import { CustomStates } from "../../../../../types/dyte";
import MeetingSetup from "./MeetingSetup";

function Meeting({
  sessionId,
  conversationPrompts,
}: {
  sessionId: string;
  conversationPrompts: string[];
}) {
  const { meeting } = useDyteMeeting();
  const [config, setConfig] = useState(defaultConfig);
  const [states, setStates] = useState<CustomStates>({
    meeting: "setup",
    sidebar: "chat",
  });

  useEffect(() => {
    if (meeting) {
      Object.assign(window, {
        meeting,
      });
      setupMeetingConfigs(meeting, states, setStates, setConfig);
    }
  }, [meeting]);

  return (
    <MeetingSetup
      meeting={meeting}
      config={config}
      states={states}
      setStates={setStates}
      sessionId={sessionId}
      conversationPrompts={conversationPrompts}
    />
  );
}

export default Meeting;
